import {
  BrowserCookieStickyBucketService,
  GrowthBook,
} from '@growthbook/growthbook-react';
import Cookies from 'js-cookie';

const VITE_GROWTHBOOK_API_HOST = import.meta.env
  .VITE_GROWTHBOOK_API_HOST as string;
const VITE_GROWTHBOOK_CLIENT_KEY = import.meta.env
  .VITE_GROWTHBOOK_CLIENT_KEY as string;
const VITE_APP_ENV = import.meta.env.VITE_APP_ENV as string;

export const gb = new GrowthBook({
  enabled: true,
  apiHost: VITE_GROWTHBOOK_API_HOST,
  clientKey: VITE_GROWTHBOOK_CLIENT_KEY,
  // Enable easier debugging during development
  enableDevMode: VITE_APP_ENV !== 'production',
  // Update the instance in realtime as features change in GrowthBook
  subscribeToChanges: true,
  stickyBucketService: new BrowserCookieStickyBucketService({
    jsCookie: Cookies,
  }),
});
